import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { User } from "../models/user";

@Injectable({ providedIn: "root" })
export class UserService {
  constructor(private readonly http: HttpClient) {}

  getAll() {
    return this.http.get<User[]>(`/users`);
  }
}
